import Vue from 'vue';
import Router from 'vue-router';
import ReviewPanel from '@pages/ReviewPanel.vue';
import Home from '@pages/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '*',
      name: 'ReviewPanel',
      component: ReviewPanel,
    },
  ],
});
